//START GENAI
import { error } from 'common/errors';
import { asyncMarkWrapper } from 'common/instrumentation';
import { VISA } from 'common/network-partners';
import { getState } from 'orch-communicator/store';

/**
 * Performs unbind operation specifically for VISA SRC network only.
 * This function is called when email hash matches to ensure proper
 * session management and prevent potential identity conflicts.
 *
 * @returns Promise that resolves to unbind response or error
 */
export default async function selectiveUnbindVisa() {
  try {
    //eslint-disable-next-line
    const vSDK = getState().srcSdks.loadedSdk as { [key: string]: any };
    const idTokens = getState().srcSdks.apiResponseCache.idTokens;

    // Check if VISA SDK is available
    if (!vSDK[VISA]) {
      return null;
    }

    let unbindResponse;

    if (idTokens.idTokens.length > 0) {
      unbindResponse = await asyncMarkWrapper(
        'selective_unbind_visa',
        VISA,
        vSDK[VISA].unbindAppInstance(idTokens)
      );
    } else {
      unbindResponse = await asyncMarkWrapper(
        'selective_unbind_visa',
        VISA,
        vSDK[VISA].unbindAppInstance({})
      );
    }

    return unbindResponse;
  } catch (e) {
    return error('AUTH_INVALID', 'Failed to invoke selective unbind for VISA');
  }
}
//END GENAI
